<template>
  <div class="teaser-card">
    <SharedLink
      v-if="link"
      :link="link"
    >
      <NuxtImg
        class="mb-sm w-full object-contain"
        data-testid="teaser-card-image"
        :src="src"
        :srcset="srcSet"
        :alt="alt"
        :title="title"
        :loading="imageLoadType"
        :preload="imageLoadType === 'eager'"
        :fetchpriority="imageLoadType === 'eager' ? 'high' : 'low'"
      />
      <NuxtImg
        v-if="isMyKikDiscount"
        class="absolute bottom-20 right-4"
        src="/img/topnav/myKiK_Vorteilskarte.png"
        :alt="$t('myKiK')"
        width="60"
        height="44"
      />
      <KikHeading
        :title="title"
        :level="4"
        title-class="font-bold hover:underline text-md mb-2"
      />
    </SharedLink>
    <p
      v-if="introduction"
      class="teaser-card__introduction m-0"
    >
      {{ introduction }}
    </p>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  src: string;
  srcSet?: unknown;
  title?: string;
  titleColor?: string;
  introduction?: string;
  introductionColor?: string;
  link?: string | object;
  isMyKikDiscount?: boolean;
  alt?: string;
}

withDefaults(defineProps<Props>(), {
  src: '/',
  title: '',
  titleColor: '',
  introduction: '',
  introductionColor: '',
  alt: '',
  link: '',
  isMyKikDiscount: false,
});

const imageLoadType = inject<HTMLImageElement['loading']>('imageLoadType', 'lazy');
</script>

<style lang="scss" scoped>
.teaser-card {
  position: relative;
  padding: 10px 10px 0;
  margin-bottom: 20px;

  &__title {
    color: v-bind(titleColor);
    font-weight: var(--font-weight--bold);

    &:hover {
      text-decoration: underline;
    }
    @include for-mobile {
      font-size: var(--font-size--sm);
    }

    @media (min-width: $tablet-min) {
      font-size: 1.25rem;
    }

    p {
      margin-bottom: var(--spacer-2xs);
    }
  }

  &__introduction {
    color: v-bind(introductionColor);
    @include for-mobile {
      font-size: var(--font-size--xs);
    }

    @media (min-width: $tablet-min) {
      font-size: var(--font-size--sm);
    }
  }
}
</style>
